import React, { Component } from 'react';

import { Row, Col } from 'reactstrap';
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";
import styles from '../doctor/adminStyles.css';
import Input from '../../components/Input/Input';
import * as actions from "../../actions/ApiActions";
import connect from 'react-redux/es/connect/connect';

class RegisterContainer extends Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    this.state = {
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      role: 'doctor'
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleEditorChange(name, value) {
    const { settings } = this.state;

    this.setState({
      [name]: value
    });
  }

  handleFormSubmit(e) {
    const {registerRequest} = this.props;

    registerRequest(this.state);

    e.preventDefault();
  }

  render() {
    const {
      firstname,
      lastname,
      email,
      password,
    } = this.state;

    return (
      <Content>
        <Section>
          <div>
            <Headline center pageTitle>
              Jetzt als Arzt registrieren
            </Headline>

          </div>

          <Row>
            <Col lg={{ size: 8, offset: 2 }}>
              <form className={styles.form} onSubmit={this.handleFormSubmit}>

                <Row>
                  <Col xs={12} sm={6}>
                    <label>Vorname</label>
                    <Input
                      type="text"
                      name="firstname"
                      value={firstname}
                      autocomplete="off"
                      onChange={this.handleInputChange}
                    />
                  </Col>

                  <Col xs={12} sm={6}>
                    <label>Nachname</label>
                    <Input
                      type="text"
                      name="lastname"
                      value={lastname}
                      autocomplete="off"
                      onChange={this.handleInputChange}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <label>E-Mail-Adresse</label>
                    <Input
                      type="text"
                      name="email"
                      value={email}
                      autocomplete="off"
                      onChange={this.handleInputChange}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <label>Passwort</label>
                    <Input
                      type="password"
                      name="password"
                      value={password}
                      autocomplete="off"
                      onChange={this.handleInputChange}
                    />
                  </Col>
                </Row>

                <Button submit pullRight>Jetzt registrieren</Button>

              </form>
            </Col>
          </Row>

        </Section>

      </Content>
    )
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    auth_loading: state.auth_loading,
    auth_error: state.auth_error,
  };
}

export default connect(mapStateToProps, actions)(RegisterContainer);



// WEBPACK FOOTER //
// ./src/container/public/RegisterContainer.js